// ═══════════════ PRESERVE CO. THEME JS ═══════════════

// Scroll animations
const obs = new IntersectionObserver((entries) => {
  entries.forEach((en, i) => {
    if (en.isIntersecting) {
      setTimeout(() => en.target.classList.add('vis'), i * 80);
      obs.unobserve(en.target);
    }
  });
}, { threshold: 0.08 });
document.querySelectorAll('.fu').forEach(el => obs.observe(el));

// Nav scroll effect
window.addEventListener('scroll', () => {
  const nav = document.querySelector('.preserve-nav');
  if (nav) nav.style.background = window.scrollY > 60 ? 'rgba(8,6,2,.98)' : 'rgba(10,8,4,.93)';
});

// Mobile nav toggle
function toggleNav() {
  const links = document.querySelector('.nav-links');
  if (!links) return;
  const open = links.style.display === 'flex';
  links.style.cssText = open ? '' : 'display:flex;flex-direction:column;position:fixed;top:68px;left:0;right:0;background:rgba(8,6,2,.98);padding:24px 32px;gap:18px;border-bottom:1px solid rgba(200,160,60,.12);z-index:998;';
}

// Stain selector and price logic now handled inline in product-main.liquid
// (removed duplicate selectStain here to prevent conflicts)

// Guide partner signup
function guideApply() {
  const email = document.getElementById('guideEmail')?.value;
  if (!email) { alert('Please enter your email address.'); return; }
  alert("Thanks! We'll be in touch at " + email + " about the guide partnership program.");
  document.getElementById('guideEmail').value = '';
}

// Product page photo upload
function handlePhoto(e) {
  var file = e.target.files[0];
  if (!file) return;
  var zone = document.getElementById('uploadZone');
  if (zone) {
    zone.style.borderColor = 'rgba(200,160,60,.6)';
    zone.style.background = 'rgba(200,160,60,.04)';
  }
  var content = document.getElementById('uploadContent');
  var done = document.getElementById('uploadDone');
  var name = document.getElementById('uploadedName');
  if (content) content.style.display = 'none';
  if (done) done.style.display = 'block';
  if (name) name.textContent = '\u2713 ' + file.name;

  // Store filename in a hidden field for the cart note
  var photoNote = document.getElementById('photoFileName');
  if (photoNote) photoNote.value = file.name;
}
